// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.benchModal {
  width: 95%;
  max-width: 1200px;
  background: white;
  border-radius: 24px;
  padding: 30px;
  /* box-shadow: 0 25px 60px rgba(0,0,0,.15); */
  max-height: 95vh;
  overflow-y: auto;

  /* Firefox */
  scrollbar-width: none;

  /* IE and Edge */
  -ms-overflow-style: none;
}

/* Chrome, Safari */
.benchModal::-webkit-scrollbar {
  display: none;
}

.benchHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.benchHeader h2 {
  font-size: 32px;
  margin: 0;
  font-weight: 700;
}

.benchHeader p {
  color: #6b7280;
}

.closeBtn {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  border: none;
  background: #f5f6fa;
  cursor: pointer;
}

.formGrid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.inputGroup {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.inputGroup label {
  font-weight: 600;
}

.inputGroup input,
.inputGroup select,
.inputGroup textarea {
  width: 100%;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  padding: 14px;
  font-size: 14px;
  outline: none;
}

.inputGroup input:focus,
.inputGroup select:focus,
.inputGroup textarea:focus {
  border-color: #4f46e5;
}

.inputWrapper {
  position: relative;
}

.inputWrapper svg {
  position: absolute;
  left: 14px;
  top: 16px;
  color: #6b7280;
}

.inputWrapper input {
  padding-left: 42px;
}

.fullWidth {
  grid-column: span 3;
}

.uploadGrid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-top: 30px;
}

.uploadBox {
  border: 2px dashed #d6d6d6;
  border-radius: 20px;
  padding: 30px;
  text-align: center;
  transition: .3s;
  cursor: pointer;
}

.uploadBox:hover {
  border-color: #4f46e5;
  background: #f8f9ff;
}

.uploadBox h4 {
  margin-top: 10px;
  color: #4f46e5;
}

.uploadLabel {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  width: 100%;
  height: 100%;
}

.modalFooter {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  margin-top: 30px;
}

.cancelBtn {
  border: none;
  background: #eef0f5;
  padding: 14px 28px;
  border-radius: 12px;
  cursor: pointer;
}

.saveBtn {
  border: none;
  color: white;
  padding: 14px 30px;
  border-radius: 12px;
  background: linear-gradient(135deg,
      #4f46e5,
      #6d28d9);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.btnLoader {
  width: 16px;
  height: 16px;
  border: 2px solid #fff;
  border-top: 2px solid transparent;
  border-radius: 50%;
  animation: spin .8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.saveBtn:disabled {
  opacity: .8;
  cursor: not-allowed;
}

@media(max-width:992px) {

  .formGrid {
    grid-template-columns: 1fr;
  }

  .fullWidth {
    grid-column: span 1;
  }

  .uploadGrid {
    grid-template-columns: 1fr;
  }
}

@media(max-width:768px) {
  .benchModal {
    width: 100%;
    max-width: 100%;
    min-height: 0;
    max-height: none;
    padding: 8px 4px 4px;
    border-radius: 0;
  }

  .benchHeader {
    position: sticky;
    z-index: 5;
    top: 0;
    margin: 0 0 16px;
    padding: 8px 2px 12px;
    background: #fff;
  }

  .benchHeader h2 {
    font-size: 21px;
    line-height: 1.2;
  }

  .benchHeader p {
    margin-top: 4px;
    font-size: 12px;
  }

  .closeBtn {
    width: 40px;
    height: 40px;
    flex: 0 0 40px;
  }

  .formGrid {
    gap: 14px;
  }

  .inputGroup input,
  .inputGroup select,
  .inputGroup textarea {
    min-height: 46px;
    padding: 12px;
    font-size: 16px;
  }

  .uploadGrid {
    gap: 12px;
    margin-top: 18px;
  }

  .uploadBox {
    min-height: 110px;
    padding: 18px 12px;
    border-radius: 14px;
  }

  .modalFooter {
    position: sticky;
    z-index: 5;
    bottom: 0;
    margin: 20px -4px -4px;
    padding: 12px 4px calc(4px + env(safe-area-inset-bottom));
    background: rgba(255,255,255,.96);
    backdrop-filter: blur(10px);
  }

  .modalFooter button {
    min-height: 46px;
    flex: 1 1;
    padding: 11px 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/forms/BenchSales.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,6CAA6C;EAC7C,gBAAgB;EAChB,gBAAgB;;EAEhB,YAAY;EACZ,qBAAqB;;EAErB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA,mBAAmB;AACnB;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,aAAa;AACf;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB;;cAEY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,iCAAiC;EACjC,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE;IACE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,WAAW;IACX,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,UAAU;IACV,MAAM;IACN,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,SAAS;EACX;;EAEA;;;IAGE,gBAAgB;IAChB,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,sBAAsB;IACtB,yDAAyD;IACzD,iCAAiC;IACjC,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;IAChB,SAAO;IACP,kBAAkB;EACpB;AACF","sourcesContent":[".benchModal {\r\n  width: 95%;\r\n  max-width: 1200px;\r\n  background: white;\r\n  border-radius: 24px;\r\n  padding: 30px;\r\n  /* box-shadow: 0 25px 60px rgba(0,0,0,.15); */\r\n  max-height: 95vh;\r\n  overflow-y: auto;\r\n\r\n  /* Firefox */\r\n  scrollbar-width: none;\r\n\r\n  /* IE and Edge */\r\n  -ms-overflow-style: none;\r\n}\r\n\r\n/* Chrome, Safari */\r\n.benchModal::-webkit-scrollbar {\r\n  display: none;\r\n}\r\n\r\n.benchHeader {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.benchHeader h2 {\r\n  font-size: 32px;\r\n  margin: 0;\r\n  font-weight: 700;\r\n}\r\n\r\n.benchHeader p {\r\n  color: #6b7280;\r\n}\r\n\r\n.closeBtn {\r\n  width: 45px;\r\n  height: 45px;\r\n  border-radius: 50%;\r\n  border: none;\r\n  background: #f5f6fa;\r\n  cursor: pointer;\r\n}\r\n\r\n.formGrid {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, 1fr);\r\n  gap: 20px;\r\n}\r\n\r\n.inputGroup {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n.inputGroup label {\r\n  font-weight: 600;\r\n}\r\n\r\n.inputGroup input,\r\n.inputGroup select,\r\n.inputGroup textarea {\r\n  width: 100%;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 14px;\r\n  padding: 14px;\r\n  font-size: 14px;\r\n  outline: none;\r\n}\r\n\r\n.inputGroup input:focus,\r\n.inputGroup select:focus,\r\n.inputGroup textarea:focus {\r\n  border-color: #4f46e5;\r\n}\r\n\r\n.inputWrapper {\r\n  position: relative;\r\n}\r\n\r\n.inputWrapper svg {\r\n  position: absolute;\r\n  left: 14px;\r\n  top: 16px;\r\n  color: #6b7280;\r\n}\r\n\r\n.inputWrapper input {\r\n  padding-left: 42px;\r\n}\r\n\r\n.fullWidth {\r\n  grid-column: span 3;\r\n}\r\n\r\n.uploadGrid {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, 1fr);\r\n  gap: 20px;\r\n  margin-top: 30px;\r\n}\r\n\r\n.uploadBox {\r\n  border: 2px dashed #d6d6d6;\r\n  border-radius: 20px;\r\n  padding: 30px;\r\n  text-align: center;\r\n  transition: .3s;\r\n  cursor: pointer;\r\n}\r\n\r\n.uploadBox:hover {\r\n  border-color: #4f46e5;\r\n  background: #f8f9ff;\r\n}\r\n\r\n.uploadBox h4 {\r\n  margin-top: 10px;\r\n  color: #4f46e5;\r\n}\r\n\r\n.uploadLabel {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  cursor: pointer;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.modalFooter {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 15px;\r\n  margin-top: 30px;\r\n}\r\n\r\n.cancelBtn {\r\n  border: none;\r\n  background: #eef0f5;\r\n  padding: 14px 28px;\r\n  border-radius: 12px;\r\n  cursor: pointer;\r\n}\r\n\r\n.saveBtn {\r\n  border: none;\r\n  color: white;\r\n  padding: 14px 30px;\r\n  border-radius: 12px;\r\n  background: linear-gradient(135deg,\r\n      #4f46e5,\r\n      #6d28d9);\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 10px;\r\n}\r\n\r\n.btnLoader {\r\n  width: 16px;\r\n  height: 16px;\r\n  border: 2px solid #fff;\r\n  border-top: 2px solid transparent;\r\n  border-radius: 50%;\r\n  animation: spin .8s linear infinite;\r\n}\r\n\r\n@keyframes spin {\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.saveBtn:disabled {\r\n  opacity: .8;\r\n  cursor: not-allowed;\r\n}\r\n\r\n@media(max-width:992px) {\n\r\n  .formGrid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .fullWidth {\r\n    grid-column: span 1;\r\n  }\r\n\r\n  .uploadGrid {\r\n    grid-template-columns: 1fr;\r\n  }\n}\n\n@media(max-width:768px) {\n  .benchModal {\n    width: 100%;\n    max-width: 100%;\n    min-height: 0;\n    max-height: none;\n    padding: 8px 4px 4px;\n    border-radius: 0;\n  }\n\n  .benchHeader {\n    position: sticky;\n    z-index: 5;\n    top: 0;\n    margin: 0 0 16px;\n    padding: 8px 2px 12px;\n    background: #fff;\n  }\n\n  .benchHeader h2 {\n    font-size: 21px;\n    line-height: 1.2;\n  }\n\n  .benchHeader p {\n    margin-top: 4px;\n    font-size: 12px;\n  }\n\n  .closeBtn {\n    width: 40px;\n    height: 40px;\n    flex: 0 0 40px;\n  }\n\n  .formGrid {\n    gap: 14px;\n  }\n\n  .inputGroup input,\n  .inputGroup select,\n  .inputGroup textarea {\n    min-height: 46px;\n    padding: 12px;\n    font-size: 16px;\n  }\n\n  .uploadGrid {\n    gap: 12px;\n    margin-top: 18px;\n  }\n\n  .uploadBox {\n    min-height: 110px;\n    padding: 18px 12px;\n    border-radius: 14px;\n  }\n\n  .modalFooter {\n    position: sticky;\n    z-index: 5;\n    bottom: 0;\n    margin: 20px -4px -4px;\n    padding: 12px 4px calc(4px + env(safe-area-inset-bottom));\n    background: rgba(255,255,255,.96);\n    backdrop-filter: blur(10px);\n  }\n\n  .modalFooter button {\n    min-height: 46px;\n    flex: 1;\n    padding: 11px 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
